/**
 * "This member used the app today" — the signal behind the GrowthSync goal measure
 * (members active on two separate days in the same week) and behind last_active_at.
 *
 * WHY THIS EXISTS (2026-10-05). user_profiles.last_active_at had never been written by anything:
 * it defaulted to now() at signup and stayed there, so "last active" really meant "joined", and the
 * weekly two-day count could only be rebuilt by hand from Supabase's auth tables.
 *
 * Two callers, both throttled to once an hour per device so this costs almost nothing:
 *   - middleware, on every app page load and client navigation (cookie throttle, see below)
 *   - ActivityHeartbeat, when the phone app or a tab comes back to the foreground without
 *     navigating (localStorage throttle)
 * Both call the record_member_activity() database function, which uses the caller's own session
 * (auth.uid()) and so can only ever mark the caller active. It writes one row per London day into
 * member_activity_days and bumps last_active_at.
 */

export const ACTIVITY_COOKIE = "gs_active_hr";
export const ACTIVITY_STORAGE_KEY = "gs-active-hr";

/** UTC hour bucket, e.g. "2026-10-05T11". Good enough for throttling; the day is decided in SQL. */
export function currentActivityHour(now: Date = new Date()): string {
  return now.toISOString().slice(0, 13);
}

export function shouldRecordActivity(lastHour: string | null | undefined, now: Date = new Date()): boolean {
  return lastHour !== currentActivityHour(now);
}
